/**
 * 后端返回值为 -1
 * 服务次数为无限(企业版)
 */
const isServiceUnlimited = (value?: number) => {
  return value === -1;
};

export default isServiceUnlimited;
